module.exports = __webpack_public_path__ + "static/media/captivating-1.faf0707a.png";